<app-layout>

    <div class="trade">

        <!-- trade head start -->
        <div class="trade-head">

            <div class="trade-head__row-left">
                <div class="trade-head__block-top">
                    <market-stats :futures="futures" :quotes="quotes" :market="market.data"></market-stats>
                </div>
                <!-- module head start -->
                <div class="module-head mobile-head-title">
                    <div class="module-orderopen__navigation">
                        <div @click="setFirstTab('orderbook')" :class="{'module-orderopen__navigation-active': mobileFirstTab == 'orderbook'}" class="module-orderopen__navigation-title"><h4>{{ $t('Orderbook') }}</h4></div>
                        <div @click="setFirstTab('chart')" :class="{'module-orderopen__navigation-active': mobileFirstTab == 'chart'}" class="module-orderopen__navigation-title"><h4>{{ $t('Chart') }}</h4></div>
                        <div @click="setFirstTab('trades')" :class="{'module-orderopen__navigation-active': mobileFirstTab == 'trades'}" class="module-orderopen__navigation-title"><h4>{{ $t('Trades') }}</h4></div>
                    </div>
                </div>
                <div class="trade-head__block-middle" v-if="mobileFirstTab == 'orderbook' || mobileFirstTab == 'chart'">
                    <div class="trade-head__left" v-if="market && mobileFirstTab == 'orderbook'" >
                        <order-book :market="market.data"></order-book>
                    </div>
                    <div class="trade-head__right" v-if="mobileFirstTab == 'chart' || !isMobile">
                        <iframe :key="chartIteration" id="market-chart" :src="chartUrl" width="100%" height="400"></iframe>
                    </div>
                </div>
                <div class="trade-body__row mob-order-open">
		    <order-form :futures="futures" :market="market.data" v-if="detectMobileDevice()" ></order-form>
                    <open-orders :futures="futures" :market="market.data"></open-orders>
                </div>
            </div>

            <div class="trade-head__row-right">
                <order-form :futures="futures" :market="market.data" v-if="!detectMobileDevice()"></order-form>
		
                <market-trades v-if="mobileFirstTab == 'trades' || !isMobile" :market="market.data"></market-trades>
            </div>

        </div>
        <!-- trade head  end -->

        <orderbook-channel :market="market.data"></orderbook-channel>
        <binance-socket :market="market.data" />
    </div>
</app-layout>

